export default "__VITE_ASSET__061efb75__"